import React, { Component } from 'react';
import { withStyles } from '@material-ui/styles';
import { withRouter } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import Paper from '@material-ui/core/Paper';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { Button, IconButton, MenuItem, OutlinedInput, Select, Typography } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import CircularProgress from '@material-ui/core/CircularProgress';
import DaumPostcode from 'react-daum-postcode';
import { Auth } from 'aws-amplify';
import swal from '@sweetalert/with-react';
import queryString from 'query-string';

import axiosInstance, {
  EVENT_ID,
  F_EMAIL,
  WEB_API,
  WELCOME_TEMPLATE,
  emailValidation,
  krMobileValidation,
  focusElementRef,
  getUserID,
  getDialingCode,
  BCC_ADDR_EMAIL_REG,
  // BCC_ADDR_EMAIL,
  // getEventId,
} from '../constatns';
import { CountryList } from '../common/CountryList';
import Container from '../components/Div/Container';
import Table from '../components/Table/Table';
import ConfirmButton from '../components/Button/ConfirmButton';
import MainTitle from '../components/Text/MainTitle';
import SubTitle from '../components/Text/SubTitle';
import AgreementDiv from '../components/Div/AgreementDiv';
import './JoinForm.css';

const axios = require('axios');
const styles = (theme) => ({
  title2: {
    fontSize: 18,
    fontWeight: 'bold',
  },
  OutlinedInput: {
    width: '100%',
    padding: '5px 7px',
    '& .MuiOutlinedInput-input': {
      padding: '4px 10px',
    },
  },
  radioGroup: {
    '& *': {
      fontSize: 14,
    },
  },
  btn: {
    padding: '5px 7px',
  },
  asteriskMark: {
    color: 'rgb(255, 0, 0)',
  },

  popupDiv: {
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0,0,0,0.4)',
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: 1111,
  },
  popupPaper: {
    display: 'block',
    position: 'fixed',
    top: '50%',
    left: '50%',
    width: '600px',
    padding: '7px',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#fff',
    zIndex: 2222,
  },
});

class JoinForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      country: '',
      email: '',
      password: '',
      chkPw: '',
      name_kor: '',
      firstName: '',
      lastName: '',
      license: '',
      title: '',
      titleOthers: '',
      kind: '',
      department: '',
      // postalCode: '',
      // address: '',
      // city: '',
      // addressEn: '',
      positionShort: '',
      position: '',
      positionEn: '',
      hp1: '',
      hp2: '',
      hp3: '',
      hp4: '',
      tel1: '',
      tel2: '',
      tel3: '',
      tel4: '',
      etc: '',
      isSubmitting: false,
      name_kor_r: '',
      ban: false,
      // 인증여부
      isConfirmed: false,
      // 인증후 수정 방지를 위한 비교 값
      confirmedKind: '',
      confirmedNumber: '', //인증된 면허번호
      confirmedName: '', //인증된 한글성명
      confirmedName_r: '', //인증된 추천인 한글성명
    };

    this.refEmail = React.createRef();
    this.refNameKr = React.createRef();
    this.refNameKrR = React.createRef();
    this.refLicense = React.createRef();

    this.goToPage = this.goToPage.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSignUp = this.handleSignUp.bind(this);
    this.idDuplicateCheck = this.idDuplicateCheck.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
    this.getUserData = this.getUserData.bind(this);
    this.inputMemberBanAuto = this.inputMemberBanAuto.bind(this);
  }

  componentDidMount() {
    const lang = queryString.parse(this.props.location.search)['lang'];
    const userId = queryString.parse(this.props.location.search)['userId'];

    // console.log(userId);
    this.getHospitalList();
    if (lang) {
      this.setState({ lang: lang }, () => {
        if (this.state.lang === 'kor') {
          this.setState({ hp1: '82', tel1: '82' });
        }
      });
    } else {
      if (this.props.lang && this.props.lang !== 'kor') {
        this.setState({ lang: 'eng' });
      } else {
        this.setState({ lang: 'kor' });
      }
    }
    if (userId) {
      this.setState({ userId: userId });
      this.getUserData(userId);
    }
    if (this.props.isMypage) {
      this.setUserData(this.props.userInfo);
    }
  }

  setUserData(data) {
    const lang = this.state.lang ? this.state.lang : this.props.lang ? this.props.lang : 'kor';
    // console.log(data);
    // console.log(lang);
    const titleArr = ['Prof.', 'Dr.', 'Mr.', 'Ms.'];
    for (const [key, value] of Object.entries(data)) {
      // console.log(key + ' : ' + value);
      if (key !== 'role' && key !== 'evt' && key !== 'isPaper' && key !== 'id' && key !== 'memNo') {
        if (key === 'username') {
          this.setState({ name_kor: value });
        } else if (key === 'postalCode') {
          this.setState({ name_kor_r: value });
        } else if (key === 'dept') {
          this.setState({ department: value });
        } else if (key === 'title') {
          this.setState({
            title: titleArr.indexOf(value) === -1 ? 'Others' : value,
            titleOthers: titleArr.indexOf(value) !== -1 ? '' : value,
          });
        } else if (key === 'address') {
          if (lang !== 'kor') {
            this.setState({
              city: value,
            });
          } else {
            this.setState({
              address: value,
            });
          }
        } else if (key === 'hp') {
          const hp = value.replace('+', '').split('-');
          this.setState({
            hp1: hp[0],
            hp2: hp[1],
            hp3: hp[2],
            hp4: hp[3],
          });
        } else if (key === 'tel') {
          const tel = value.replace('+', '').split('-');
          this.setState({
            tel1: tel[0],
            tel2: tel[1],
            tel3: tel[2],
            tel4: tel[3],
          });
        } else {
          this.setState({ [key]: value });
        }
      }
    }
  }

  getUserData(id) {
    // const userId = queryString.parse(this.props.location.search)['userId'];
    axiosInstance.get(`${WEB_API}/user/info?eventId=${EVENT_ID}&userId=${id}`).then((res) => {
      if (res.data && res.data.Item) {
        for (const [key, value] of Object.entries(res.data.Item)) {
          if (key === 'dept') {
            this.setState({ department: value });
          } else {
            this.setState({ [key]: value });
          }
        }
        const hp = res.data.Item.hp.replace('+', '').split('-');
        const tel = res.data.Item.tel.replace('+', '').split('-');
        const titleArr = ['Prof.', 'Dr.', 'Mr.', 'Ms.'];
        this.setState({
          name_kor: res.data.Item.username,
          hp1: hp[0],
          hp2: hp[1],
          hp3: hp[2],
          hp4: hp[3],
          tel1: tel[0],
          tel2: tel[1],
          tel3: tel[2],
          tel4: tel[3],
          title: titleArr.indexOf(res.data.Item.title) === -1 ? 'Others' : res.data.Item.title,
          titleOthers: titleArr.indexOf(res.data.Item.title) !== -1 ? '' : res.data.Item.title,
        });
      }
    });
  }

  getHospitalList() {
    // 2022 custom : 병원 리스트 변동 없는 지 확인 필요
    axiosInstance.get(`${WEB_API}/user/hospital/`).then((res) => {
      // console.log(res.data);
      let list = res.data;
      list.sort((a, b) => {
        return Number(a.order) - Number(b.order);
      });
      this.setState({ hospitalList: list });
    });
  }

  goToPage(_move) {
    this.props.history.push(_move);
  }

  capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }

  capitalizeFirstLetterInWord(str) {
    let buff = str.split(' ');
    for (let i = 0; i < buff.length; i++) {
      buff[i] = buff[i].charAt(0).toUpperCase() + buff[i].slice(1).toLowerCase();
    }

    return buff.join().replace(/,/g, ' ');
  }

  handleChange(type, e) {
    this.setState({ [type]: e.target.value }, () => {
      if (type === 'title' && this.state.title === 'Others') {
        document.getElementById('titleOthers').focus();
      }

      //회원구분 입력 후 수정방지
      if (type === 'kind') {
        if (this.state.isConfirmed === true && this.state.kind !== this.state.confirmedKind) {
          this.setState({ isConfirmed: false });
          swal('인증된 항목 수정', '다시 인증해 주세요.', 'warning');
        }
      }

      //면허번호 입력 후 수정방지
      if (type === 'license') {
        if (this.state.isConfirmed === true && this.state.license !== this.state.confirmedNumber) {
          this.setState({ isConfirmed: false });
          swal('인증된 항목 수정', '다시 인증해 주세요.', 'warning');
        }
      }

      // 성명(한글)입력 및 인증 후 수정 방지
      if (type === 'name_kor') {
        const name_kor = this.state.name_kor;
        //console.log(/^[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/g.test(name_kor));
        if (name_kor && !/^[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/g.test(name_kor)) {
          swal('한글만 입력 가능합니다.').then(() => {
            this.setState({ name_kor: '' }, () => {
              document.getElementById('name_kor').focus();
            });
          });
          return false;
        }

        this.setState({ name_kor: name_kor }, () => {
          if (this.state.isConfirmed === true && this.state.name_kor !== this.state.confirmedName) {
            this.setState({ isConfirmed: false });
            swal('인증된 항목 수정', '다시 인증해 주세요.', 'warning');
          }
        });

        // this.setState({ name_kor: this.capitalizeFirstLetter(name_kor) }
      }

      // 추천인 성명(한글)입력 및 인증 후 수정 방지
      if (type === 'name_kor_r') {
        const name_kor_r = this.state.name_kor_r;
        //console.log(/^[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/g.test(name_kor));
        if (name_kor_r && !/^[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/g.test(name_kor_r)) {
          swal('한글만 입력 가능합니다.').then(() => {
            this.setState({ name_kor_r: '' }, () => {
              document.getElementById('name_kor_r').focus();
            });
          });
          return false;
        }

        this.setState({ name_kor_r: name_kor_r }, () => {
          if (this.state.isConfirmed === true && this.state.name_kor_r !== this.state.confirmedName_r) {
            this.setState({ isConfirmed: false });
            swal('인증된 항목 수정', '다시 인증해 주세요.', 'warning');
          }
        });

        // this.setState({ name_kor: this.capitalizeFirstLetter(name_kor) }
      }

      if (type === 'lastName') {
        const lastName = this.state.lastName;
        //console.log(/^[A-za-z]/g.test(lastName));
        if (lastName && !/^[A-Za-z]/g.test(lastName)) {
          swal('Please enter English only.').then(() => {
            this.setState({ lastName: '' }, () => {
              document.getElementById('lastName').focus();
            });
          });
          return false;
        }
        // this.setState({ lastName: this.capitalizeFirstLetter(lastName) });
        this.setState({ lastName: lastName });
      }
      if (type === 'firstName') {
        const firstName = this.state.firstName;
        //console.log(/^[A-za-z]/g.test(firstName));
        if (firstName && !/^[A-Za-z]/g.test(firstName)) {
          swal('Please enter English only.').then(() => {
            this.setState({ firstName: '' }, () => {
              document.getElementById('firstName').focus();
            });
          });
          return false;
        }

        // this.setState({ firstName: this.capitalizeFirstLetterInWord(firstName) });
        this.setState({ firstName: firstName });
        // this.setState({ firstName: this.capitalizeFirstLetter(firstName) });
      }

      if (type === 'positionEn') {
        const positionEn = this.state.positionEn;
        //console.log(/^[A-za-z]/g.test(firstName));
        if (positionEn && !/^[A-Za-z]/g.test(positionEn)) {
          // swal('영문만 입력 가능합니다.').then(() => {
          swal('Please enter English only.').then(() => {
            this.setState({ positionEn: '' }, () => {
              document.getElementById('positionEn').focus();
            });
          });
          return false;
        }
        // this.setState({ positionEn: this.capitalizeFirstLetter(positionEn) });
        this.setState({ positionEn: positionEn });
      }
    });
  }

  handleSignUp() {
    const lang = this.state.lang;

    // if (lang === 'kor' && !this.state.isConfirmed && this.state.name_kor && this.state.license) {
    //   if (this.state.kind === '동반인' || this.state.kind === '국내연수 외국인의사') {
    //     swal('추천인 이름과 의사면허번호가 일치하지 않습니다. 인증 완료 후 가입이 가능합니다.');
    //   } else {
    //     swal('의사면허번호와 이름이 일치하지 않습니다. 인증 완료 후 가입이 가능합니다.');
    //   }
    //   // return false;
    // } else
    if (!this.state.agree) {
      if (lang === 'kor') {
        // swal('개인정보 이용약관에 동의해주시기 바랍니다. ');
        swal('Please agree to the privacy terms.');
      } else {
        swal('Please agree to the privacy terms.');
      }
    } else if (lang === 'eng' && !this.state.country) {
      swal('Please select a country');
    } else if (!this.state.email) {
      swal('Please enter your ID.').then(() => {
        document.getElementById('email').focus();
      });
    } else if (!this.state.avalId) {
      swal('Please verify your E-mail duplicate.');
    } else if (!this.state.password) {
      swal('Please enter your password.').then(() => {
        document.getElementById('password').focus();
      });
    } else if (!this.state.chkPw) {
      swal('Please enter password confirmation.').then(() => {
        document.getElementById('chkPw').focus();
      });
    } else if (this.state.password !== this.state.chkPw) {
      swal('Password do not match').then(() => {
        document.getElementById('chkPw').focus();
      });
    } else if (lang === 'kor' && !this.state.name_kor && this.state.kind !== '국내연수 외국인의사') {
      swal('Please enter your Korean name.').then(() => {
        document.getElementById('name_kor').focus();
      });
    } else if ((this.state.kind === '동반인' || this.state.kind === '국내연수 외국인의사') && !this.state.name_kor_r) {
      swal('추천인 성명(국문)을 입력해주세요.').then(() => {
        document.getElementById('name_kor_r').focus();
      });
    } else if (!this.state.lastName) {
      swal('Please enter your last name.').then(() => {
        document.getElementById('lastName').focus();
      });
    } else if (!this.state.firstName) {
      swal('Please enter your first name.').then(() => {
        document.getElementById('firstName').focus();
      });
    } else if (lang === 'kor' && !this.state.license) {
      if (this.state.kind === '동반인' || this.state.kind === '국내연수 외국인의사') {
        swal('추천인 의사면허번호를 입력해주세요.').then(() => {
          document.getElementById('license').focus();
        });
      } else {
        swal('Please enter your license number.').then(() => {
          // swal('', '의사면허번호를 확인해주세요.', 'error').then(() => {
          document.getElementById('license').focus();
        });
      }
    } else if (!this.state.title) {
      swal('Please select your title.');
    } else if (this.state.title === 'Others' && !this.state.titleOthers) {
      swal('Please enter your other title.');
    } else if (lang === 'kor' && !this.state.kind) {
      swal('Please select a category.');
    } else if (lang === 'eng' && !this.state.department) {
      swal('Please enter your department.').then(() => {
        document.getElementById('department').focus();
      });
    } else if (lang === 'kor' && !this.state.position) {
      swal('Please enter your affiliation').then(() => {
        document.getElementById('position').focus();
      });
    } else if (!this.state.positionEn) {
      if (lang === 'kor') {
        swal('Please enter your affiliation English name.').then(() => {
          document.getElementById('positionEn').focus();
        });
      } else {
        swal('Please enter your affiliation.').then(() => {
          document.getElementById('positionEn').focus();
        });
      }
    }
    //  else if (lang === 'kor' && !this.state.postalCode) {
    //   swal('Please enter your postal code').then(() => {
    //     document.getElementById('postalCode').focus();
    //   });
    // } else if (lang === 'kor' && !this.state.address) {
    //   swal('Please enter your address.').then(() => {
    //     document.getElementById('address').focus();
    //   });
    // } else if (lang === 'kor' && !this.state.addressEn) {
    //   swal('Please enter your address in English.').then(() => {
    //     document.getElementById('addressEn').focus();
    //   });
    // } else if (lang === 'eng' && !this.state.addressEn) {
    //   swal('Please enter your address.').then(() => {
    //     document.getElementById('addressEn').focus();
    //   });
    // } else if (lang === 'eng' && !this.state.city) {
    //   swal('Please enter city.').then(() => {
    //     document.getElementById('city').focus();
    //   });
    // }
    else if (lang === 'kor' && (!this.state.hp1 || !this.state.hp2 || !this.state.hp3 || !this.state.hp4)) {
      swal('Please enter your mobile phone number');
    } else if (lang === 'eng' && (!this.state.hp1 || !this.state.hp2)) {
      swal('Please enter your mobile phone number');
    } else {
      if (lang === 'kor') {
        const krMobileNum = this.state.hp2 + this.state.hp3 + this.state.hp4;
        if (!krMobileValidation(krMobileNum)) {
          swal('Please check your mobile phone number is valid');
          return false;
        }
        if (this.state.name_kor && !/([가-힣]{2,})/gi.test(this.state.name_kor)) {
          focusElementRef('Please check your Korean name is valid', this.refNameKr);
          return false;
        }
        if (!this.state.isConfirmed) {
          focusElementRef('Please check your license number.', this.refLicense);
          // focusElementRef('의사면허번호를 확인해주세요.', this.refLicense);
          return false;
        }
      } else {
        if (!/^(\d{8,20})$/gi.test(this.state.hp1 + this.state.hp2)) {
          swal('Please check your mobile phone number is valid');
          return false;
        }
      }
      if (!/([A-Za-z'-\s]{1,})/gi.test(this.state.firstName) || !/([A-Za-z'-\s]{1,})/gi.test(this.state.lastName)) {
        let msg = lang === 'kor' ? 'Please check your English name is valid' : 'Please check your name is valid';
        swal(msg);
        return false;
      }

      let pwd = ('' + this.state.password).replace(/ /gi, '');
      if (('' + this.state.password).length < 6) {
        pwd = this.state.password.padEnd(6, '0');
      }

      Auth.signUp({
        username: EVENT_ID + '_' + this.state.email,
        password: pwd,
        attributes: {
          email: this.state.email,
          'custom:country': this.state.lang === 'kor' ? 'Korea, Republic of' : this.state.country,
          'custom:in_name':
            this.state.lang === 'kor' && this.state.kind !== '국내연수 외국인의사'
              ? this.state.name_kor
              : this.state.firstName + ' ' + this.state.lastName,
          'custom:in_email': this.state.email,
          'custom:in_name_en': this.state.firstName + ' ' + this.state.lastName,
          'custom:first_name': this.state.firstName,
          'custom:last_name': this.state.lastName,
          'custom:license':
            this.state.kind === '동반자' || this.state.kind === '국내연수 외국인의사' ? '(추천)' + this.state.license : this.state.license,
          'custom:title': this.state.title === 'Others' ? this.state.titleOthers : this.state.title,
          'custom:kind': this.state.kind,
          'custom:position': this.state.position,
          'custom:position_en': this.state.positionEn,
          'custom:address': this.state.lang === 'kor' ? this.state.address : this.state.city,
          'custom:address_en': this.state.addressEn,
          'custom:postal_code':
            this.state.kind === '동반자' || this.state.kind === '국내연수 외국인의사' ? '(추천)' + this.state.name_kor_r : '',
          'custom:hp':
            this.state.lang === 'kor'
              ? `+${this.state.hp1}-${this.state.hp2}-${this.state.hp3}-${this.state.hp4}`
              : `+${this.state.hp1}-${this.state.hp2}`,
          'custom:tel':
            this.state.lang === 'kor'
              ? `+${this.state.tel1}-${this.state.tel2}-${this.state.tel3}-${this.state.tel4}`
              : `+${this.state.tel1}-${this.state.tel2}`,
          'custom:etc': this.state.etc,
          'custom:role': 'SCRL_USR',
          'custom:isPay': 'P',
          'custom:psession': pwd,
          'custom:dept': this.state.department,
          'custom:evt': EVENT_ID,
        },
      })
        .then((user) => {
          // 웰컴 메일 전송 및 memNo 업데이트
          let sendParam = {};
          for (const [key, value] of Object.entries(this.state)) {
            if (key !== 'hospitalList' && key !== 'department') {
              sendParam[key] = value;
            }
          }

          sendParam.userId = EVENT_ID + '_' + this.state.email;
          sendParam.evt = EVENT_ID;
          sendParam.from = F_EMAIL;

          sendParam.to = [this.state.email];
          // sendParam.bcc = BCC_ADDR_EMAIL;
          sendParam.bcc = BCC_ADDR_EMAIL_REG;
          // sendParam.to = [this.state.email, 'secretariat.kprs@innon.co.kr', 'jhshin@innon.co.kr'];
          sendParam.address = this.state.lang === 'kor' ? this.state.address : this.state.city;
          sendParam.userName = this.state.lang === 'kor' ? this.state.name_kor : this.state.firstName + ' ' + this.state.lastName;
          sendParam.templateName = this.state.lang === 'kor' ? WELCOME_TEMPLATE + 'Kor' : WELCOME_TEMPLATE;
          sendParam._title = this.state.title === 'Others' ? this.state.titleOthers : this.state.title;
          if (this.state.lang === 'kor') {
            sendParam.country = 'Korea, Republic of';
          } else {
            sendParam['dept'] = this.state.department;
          }
          axiosInstance.post(WEB_API + '/user/welcome', sendParam).then((d) => {});
          // console.log(user);

          // swal('', '회원가입이 완료되었습니다(Sign up is complete).', 'success').then((confirm) => {
          swal('', 'Sign up is complete.', 'success').then((confirm) => {
            if (confirm) {
              // console.log(queryString.parse(this.props.location.search)['lang']);
              const querySearch = queryString.parse(this.props.location.search);
              this.props.history.push({
                pathname: `/confirm_signup`,
                search: `?lang=${querySearch['lang'] || 'kor'}&email=${sendParam.email}`,
                state: { userInfo: sendParam },
              });
            }
          });
        })
        .catch((err) => {
          console.log(err);
          //swal('Registration failed. please try again.');
          swal(err.message);
        });
    }
  }

  handleUpdate() {
    const lang = this.state.lang ? this.state.lang : this.props.lang;
    const userId = queryString.parse(this.props.location.search)['userId'];
    const isAdmin = queryString.parse(this.props.location.search)['isAdmin'];
    if (this.props.isMypage) {
      for (const [key, value] of Object.entries(this.state)) {
        if (key === 'password' && value === '') {
          swal('Please enter password.');
          return;
        }
        if (key === 'chkPw' && value === '') {
          swal('Please enter password confirmation.');
          return;
        }
        // if (lang === 'kor' && key === 'name_kor' && value === '') {
        //   swal('Please enter your Korean name.');
        //   return;
        // }
        if (key === 'firstName' && value === '') {
          swal('Please enter your first name.');
          return;
        }
        if (key === 'lastName' && value === '') {
          swal('Please enter your last name.');
          return;
        }
        // if (lang === 'kor' && key === 'license' && value === '') {
        //   swal('Please enter your license number.');
        //   return;
        // }
        if (key === 'title' && value === '') {
          swal('Please select your title.');
          return;
        }
        if (this.state.title === 'Others' && key === 'titleOthers' && value === '') {
          swal('Please enter your title.');
          return;
        }
        if (lang === 'kor' && key === 'kind' && value === '') {
          swal('Please select a category.');
          return;
        }
        if (lang === 'eng' && key === 'department' && value === '') {
          swal('Please enter your department.');
          return;
        }
        if (lang === 'kor' && key === 'position' && value === '') {
          swal('Please enter your affiliation');
          return;
        }
        if (key === 'positionEn' && value === '') {
          swal(lang === 'kor' ? 'Please enter your affiliation English name.' : 'Please enter your affiliation');
          return;
        }
        // if (lang === 'kor' && key === 'postalCode' && value === '') {
        //   swal('Please enter your postal code.');
        //   return;
        // }
        // if (lang === 'kor' && key === 'address' && value === '') {
        //   swal('Please enter your address.');
        //   return;
        // }
        // if (key === 'addressEn' && value === '') {
        //   swal(lang === 'kor' ? 'Please enter your address in English.' : 'Please enter your address.');
        //   return;
        // }
        // if (lang === 'eng' && key === 'city' && value === '') {
        //   swal('Please enter city.');
        //   return;
        // }
        if (lang === 'kor' && (key === 'hp1' || key === 'hp2' || key === 'hp3' || key === 'hp4')) {
          if (value === '') {
            swal('Please enter your mobile phone number');
            return;
          }
        }
        if (lang === 'eng' && (key === 'hp1' || key === 'hp2')) {
          if (value === '') {
            swal('Please enter your mobile phone number');
            return;
          }
        }
      }

      if (this.state.password !== this.state.chkPw) {
        swal('Password do not match');
        return;
      }
      if (lang === 'kor') {
        if (!krMobileValidation(this.state.hp2 + this.state.hp3 + this.state.hp4)) {
          swal('Please check your mobile phone number is valid');
          return;
        }
        // if (!/([가-힣]{2,})/gi.test(this.state.name_kor)) {
        //   swal('Please check your Korean name is valid');
        //   return;
        // }
      }
      if (!/([a-z'-\s]{1,})/gi.test(this.state.firstName) || !/([a-z'-\s]{1,})/gi.test(this.state.lastName)) {
        let msg = lang === 'kor' ? 'Please check your English name is valid' : 'Please check your name is valid';
        swal(msg);
        return;
      }
    }

    this.setState({ isSubmitting: true });

    let updateParam = {};
    for (const [key, value] of Object.entries(this.state)) {
      if (
        key !== 'country' &&
        key !== 'hospitalList' &&
        key !== 'isSubmitting' &&
        key !== 'isConfirmed' &&
        key !== 'name_kor' &&
        key !== 'chkPw' &&
        key !== 'department' &&
        key !== 'license' &&
        // key !== 'address' &&
        // key !== 'city' &&
        key !== 'hp1' &&
        key !== 'hp2' &&
        key !== 'hp3' &&
        key !== 'hp4' &&
        key !== 'tel1' &&
        key !== 'tel2' &&
        key !== 'tel3' &&
        key !== 'tel4' &&
        key !== 'title'
      ) {
        updateParam[key] = value;
      }
    }
    updateParam.in_name_en = this.state.firstName + ' ' + this.state.lastName;
    updateParam.username = lang === 'kor' ? this.state.name_kor : this.state.firstName + ' ' + this.state.lastName;
    //updateParam.address = lang === 'kor' ? this.state.address : this.state.city;
    updateParam.hp =
      lang === 'kor' ? `+${this.state.hp1}-${this.state.hp2}-${this.state.hp3}-${this.state.hp4}` : `+${this.state.hp1}-${this.state.hp2}`;
    updateParam.tel =
      lang === 'kor'
        ? `+${this.state.tel1}-${this.state.tel2}-${this.state.tel3}-${this.state.tel4}`
        : `+${this.state.tel1}-${this.state.tel2}`;
    updateParam.title = this.state.title === 'Others' ? this.state.titleOthers : this.state.title;
    updateParam.evt = EVENT_ID;

    if (isAdmin) {
      // userId는 파라미터로 넘어온 아이디,
      // modUserId 는 현재 로그인한 관리자 아이디
      updateParam.userId = userId;
      updateParam.modUserId = getUserID(true);
    } else {
      updateParam.userId = getUserID(true);
    }
    if (lang === 'kor') updateParam['license'] = this.state.license;
    if (lang !== 'kor') updateParam['dept'] = this.state.department;

    // console.log(updateParam);

    axiosInstance
      .put(`${WEB_API}/user/`, updateParam)
      .then((d) => {
        swal('', 'The modification is complete.', 'success').then(() => {
          if (this.props.isMypage) {
            this.props.cancelModInfo();
          } else {
            window.opener = 'Self';
            window.close(); // 일반적인 현재 창 닫기
          }
        });
      })
      .catch((err) => {
        console.error(err);
        swal('Error occured while modify your information. Please try again.');
      })
      .finally(() => {
        this.setState({ isSubmitting: false });
      });
  }

  idDuplicateCheck() {
    if (!emailValidation(this.state.email)) {
      focusElementRef('Email address seems incorrect (check @ and .’s)', this.refEmail);
      return false;
    } else {
      axios
        .get(`${WEB_API}/user/checkId?eventId=${EVENT_ID}&userId=${EVENT_ID}_${this.state.email}`, { headers: { Pragma: 'no-cache' } })
        .then((res) => {
          if (res.data.exists) {
            swal('', 'This ID is used. Please type in a new ID.', 'error');
          } else {
            swal('', 'Available to use.', 'success');
            this.setState({ avalId: true });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  handleCancel = () => {
    if (this.props.type === 'JOIN') {
      this.props.history.push('/choose');
    } else {
      if (this.props.userId) {
        this.props.cancelModInfo();
      } else {
        window.opener = 'Self';
        window.close(); // 일반적인 현재 창 닫기
      }
    }
  };

  setPopupOpen() {
    let divEle = document.getElementById('subroot').children[0];
    divEle.style.overflowY = 'hidden';
    this.setState({ popUpOpen: true });
  }

  setPopupClose() {
    let divEle = document.getElementById('subroot').children[0];
    divEle.style.overflowY = 'auto';
    this.setState({ popUpOpen: false });
  }

  selectPositionKr(nameKr) {
    const { hospitalList } = this.state;
    if (hospitalList) {
      for (let i = 0; i < hospitalList.length; i++) {
        if (nameKr === '기타') {
          this.setState({
            positionShort: '기타',
            position: '',
            positionEn: '',
            // postalCode: '',
            // address: '',
            // addressEn: '',
          });
        } else {
          if (hospitalList[i].office_k === nameKr) {
            this.setState({
              positionShort: hospitalList[i].office_k,
              position: hospitalList[i].office_k,
              positionEn: hospitalList[i].office_e ? hospitalList[i].office_e : '',
              // postalCode: hospitalList[i].new_post ? hospitalList[i].new_post : '',
              // address: hospitalList[i].addr_k ? hospitalList[i].addr_k : '',
              // addressEn: hospitalList[i].addr_e ? hospitalList[i].addr_e : '',
            });
          }
        }
      }
    }
  }

  selectDialingCodeAuto(name) {
    this.setState({
      country: name,
      hp1: getDialingCode(name),
      tel1: getDialingCode(name),
    });
  }

  confirmMember = () => {
    if (this.state.kind === '') {
      swal('', '회원구분에 체크해 주세요.');
      return false;
    }

    if (this.state.kind === '동반자' || this.state.kind === '국내연수 외국인의사') {
      if (!this.state.name_kor_r) {
        this.setState({ isConfirmed: false }, () => {
          focusElementRef('이름을 입력해주세요.', this.refNameKrR);
        });
        return false;
      }
    }

    if (!this.state.license) {
      this.setState({ isConfirmed: false }, () => {
        focusElementRef('의사면허번호를 입력해주세요.', this.refLicense);
      });
      return false;
    }

    const checkName =
      this.state.kind === '동반자' || this.state.kind === '국내연수 외국인의사' ? this.state.name_kor_r : this.state.name_kor;

    axios
      .get(`${WEB_API}/user/check?eventId=${EVENT_ID}&username=${encodeURIComponent(checkName)}&license=${this.state.license}`)
      .then((res) => {
        if (res.status === 200 && res.data.length > 0) {
          if (res.data[0].discip === 'Y') {
            // if (res.data[0].memKind.indexOf('징계') !== -1) {
            swal(
              <div>
                등록불가한 회원입니다. 사무국으로 문의하시기 바랍니다.
                <br />
                <span style={{ color: 'red', textAlign: 'right' }}>(Tel.02-3487-8252)</span>
              </div>,
            );
            this.inputMemberBanAuto('isban');
          } else {
            // if (this.state.kind !== '국내연수 외국인의사' && this.state.kind !== '동반자') {
            //   axios.get(`${WEB_API}/user/checkExists?eventId=${EVENT_ID}&license=${this.state.license}`).then((res) => {
            //     if (res.status === 200) {
            //       swal('', '이미 등록된 면허번호입니다.', 'warning');
            //       return;
            //     }
            //   });
            // } else {
            //   this.setState({ isConfirmed: true }, () => {
            //     swal('', '인증이 완료되었습니다.', 'success');
            //     this.inputMemberBanAuto('unban');
            //     if (this.state.kind !== '국내연수 외국인의사' && this.state.kind !== '동반자') {
            //       this.inputMemberInfoAuto(res.data[0]);
            //     }
            //   });
            // }

            if (this.state.kind !== '국내연수 외국인의사' && this.state.kind !== '동반자') {
              axios.get(`${WEB_API}/user/checkExists?eventId=${EVENT_ID}&license=${this.state.license}`).then((res) => {
                // console.log(res);
                if (res.status === 200 && res.data > 0) {
                  swal('', '이미 등록된 면허번호입니다.', 'warning');
                  return;
                } else {
                  this.setState(
                    {
                      isConfirmed: true,
                      confirmedName: this.state.name_kor,
                      confirmedNumber: this.state.license,
                      confirmedKind: this.state.kind,
                    },
                    () => {
                      swal('', '인증이 완료되었습니다.', 'success');
                      this.inputMemberBanAuto('unban');
                      // this.inputMemberInfoAuto(res.data[0]);
                    },
                  );
                }
              });
            } else {
              this.setState(
                {
                  isConfirmed: true,
                  confirmedName_r: this.state.name_kor_r,
                  confirmedNumber: this.state.license,
                  confirmedKind: this.state.kind,
                },
                () => {
                  swal('', '인증이 완료되었습니다.', 'success');
                  this.inputMemberBanAuto('unban');
                  // if (this.state.kind !== '국내연수 외국인의사' && this.state.kind !== '동반자') {
                  //   this.inputMemberInfoAuto(res.data[0]);
                  // }
                },
              );
            }
          }
        } else {
          focusElementRef('의사면허번호를 확인해주세요', this.refLicense);
        }
      });
  };

  inputMemberBanAuto(result) {
    // const { ban } = this.state;
    if (result === 'isban') {
      this.setState({ ban: true });
    } else {
      this.setState({ ban: false });
    }
  }

  inputMemberInfoAuto(info) {
    const { hospitalList } = this.state;

    // 구분 자동입력
    // if (info.memCate === '전공의') this.setState({ kind: '전공의' });
    // else {
    //   if (info.memKind.indexOf('개원가') !== -1) this.setState({ kind: '개원의' });
    //   else if (info.memKind.indexOf('공중보건의') !== -1) this.setState({ kind: '군의관_공보의' });
    //   else if (info.memKind.indexOf('종합병원') !== -1) this.setState({ kind: '기타종합병원_봉직의' });
    //   else if (info.memKind.indexOf('수련병원') !== -1) this.setState({ kind: '수련병원_봉직의' });
    //   else this.setState({ kind: '기타' });
    // }

    // 소속 자동입력
    for (let i = 0; i < hospitalList.length; i++) {
      if (info.position) {
        if (info.position.indexOf(hospitalList[i].office_k) !== -1) {
          this.setState({
            positionShort: hospitalList[i].office_k,
            position: hospitalList[i].office_k,
            positionEn: hospitalList[i].office_e,
          });
          break;
        } else {
          this.setState({
            positionShort: '기타',
            position: info.position,
            positionEn: '',
          });
        }
      } else {
        this.setState({
          positionShort: '기타',
          position: '',
          positionEn: '',
        });
      }
    }

    // 핸드폰 번호 자동입력
    if (info.hp) {
      let hp = info.hp.split('-');
      if (hp.length > 0) {
        for (let i = 0; i < hp.length; i++) {
          hp[i] = hp[i].replace(/[^0-9]/g, '');
          this.setState({ [`hp${i + 2}`]: hp[i] });
        }
      }
    }
  }

  render() {
    const { classes } = this.props;
    const lang = this.state.lang ? this.state.lang : 'kor';
    const handleComplete = (data) => {
      this.setState({ address: data.address, addressEn: data.addressEnglish, postalCode: data.zonecode }, () => {
        this.setPopupClose();
      });
    };
    // console.log(this.state.kind, '타입');
    // console.log(this.state.isConfirmed, '인증');
    // console.log(this.state.confirmedName, '인증성명');
    // console.log(this.state.name_kor, '성명(한글)');
    // console.log(this.state.name_kor_r, '성명(한글)r');
    // console.log(this.state.confirmedName_r, '인증성명r');

    return (
      <>
        <Container>
          <Grid container justifyContent={'center'}>
            {this.props.type === 'JOIN' ? (
              <Grid item xs={8}>
                <MainTitle>Sign-Up</MainTitle>
              </Grid>
            ) : null}
            <Grid item xs={8} style={this.props.type === 'JOIN' ? { display: 'block' } : { display: 'none' }}>
              <SubTitle>Agreement for Collection and Use of Personal Information / Privacy Policy</SubTitle>
              <AgreementDiv>
                {lang === 'kor' ? (
                  <div>
                    <b>개인정보의 수집 및 이용목적</b>
                    <br />
                    PRS KOREA 2022은 2022년 국제학술대회의 온라인 사전등록 서비스를 해드리고 있습니다.
                    <br />
                    가입정보는 PRS KOREA 2022 등록 및 홈페이지 이용을 위한 용도로만 사용하며, 이 때 회원님께서 제공해주신 개인정보를
                    바탕으로 회원님의 행사 참석과 등록비 결제가 가능하게 됩니다.
                    <br /> <br />
                    <b>수집하는 개인정보의 항목</b> <br />
                    PRS KOREA 2022은 학술행사 사전등록을 위해 개인정보를 요구하고 있습니다. <br />
                    국가, 아이디(E-mail), 성명(국/영문), 구분, 소속(국/영문), 의사면허번호, 휴대전화번호를 필수 입력사항으로 수집하고
                    있습니다.
                    <br />
                    <br />
                    <b>개인정보의 보유 및 이용기간</b> <br />
                    회원님이 PRS KOREA 2022에 제공하는 서비스를 받는 동안 회원님의 개인정보는 PRS KOREA 2022에서 계속 보유하며 서비스 제공을
                    위해 이용하게 됩니다.
                  </div>
                ) : (
                  <div>
                    <b>Purposes</b>
                    <br />
                    Korean Society of Plastic and Reconstructive Surgeons provides online pre-registration for PRS KOREA 2022. By providing
                    personal information, you will be able to pay for registration and attend the conference.
                    <br />
                    <br />
                    <b>Items of Personal Information Collection</b> <br />
                    To complete online pre-registration, you will be asked to fill out your Name, ID (E-mail), Password, Country, Title,
                    Affiliation, Department and Mobile Number.
                    <br />
                    <br />
                    <b>Retention and Use of Personal Information</b> <br />
                    PRS KOREA 2022 collects and retains personal information for the duration of the conference and will use to provide
                    certain services such as newsletters and any updates on the conference.
                  </div>
                )}
              </AgreementDiv>
              <Grid style={{ textAlign: 'right', marginBottom: '50px' }}>
                <FormControlLabel
                  control={
                    <Radio
                      required
                      color="primary"
                      onChange={(e) => {
                        this.setState({ agree: 'Y' });
                      }}
                    />
                  }
                  labelPlacement="end"
                  label={lang === 'kor' ? '동의합니다.' : 'I have read and agree to the Privacy Policy above.'}
                  className={classes.ctrlLabel}
                />
              </Grid>
            </Grid>
            <Grid item xs={this.props.type === 'JOIN' ? 8 : 12} style={this.props.type === 'JOIN' ? { padding: 0 } : { padding: 20 }}>
              <SubTitle>Personal Information</SubTitle>
              <p>
                * All requested filed(<span className={classes.asteriskMark}>*</span>) should be completed.
              </p>
              <Table>
                <TableBody>
                  <TableRow>
                    <TableCell component={'th'} width="15%">
                      <b>
                        <span>*&nbsp;</span>Country
                      </b>
                    </TableCell>
                    <TableCell>
                      {lang === 'kor' ? (
                        'Korea, Republic of'
                      ) : this.props.type === 'JOIN' ? (
                        <FormControl variant="outlined" size={'small'} style={{ width: '49%' }}>
                          <Select
                            id="country-select"
                            required
                            displayEmpty
                            value={this.state.country}
                            onChange={(e) => {
                              // let selected = e.target.value;
                              //console.log(selected);
                              this.selectDialingCodeAuto(e.target.value);
                              // this.setState({
                              //   hp1: selected === '' ? '' : selected.dialingCode,
                              //   tel1: selected === '' ? '' : selected.dialingCode,
                              //   country: selected === '' ? '' : selected.name,
                              // });
                            }}
                          >
                            <MenuItem value={''}>SELECT</MenuItem>
                            {CountryList.map((country, cIdx) => {
                              return (
                                <MenuItem value={country.name} key={`country-select-item-${cIdx}`}>
                                  {country.name}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                      ) : (
                        this.state.country
                      )}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell component={'th'}>
                      <b>
                        <span>*&nbsp;</span>ID(E-mail){' '}
                      </b>
                    </TableCell>
                    {this.props.type === 'JOIN' ? (
                      <TableCell>
                        <OutlinedInput
                          required
                          className={classes.OutlinedInput}
                          style={{ width: '71%' }}
                          id="email"
                          onChange={(e) => {
                            this.handleChange('email', e);
                            this.setState({ avalId: false });
                          }}
                          value={this.state.email}
                          inputRef={this.refEmail}
                          disabled={this.state.ban}
                        />
                        <Button
                          variant="contained"
                          color="primary"
                          disableElevation
                          className={classes.btn}
                          disabled={!this.state.email}
                          style={{ width: '27%', height: '37px', fontSize: '1em', float: 'right' }}
                          onClick={this.idDuplicateCheck}
                        >
                          Check availability of this ID
                        </Button>
                      </TableCell>
                    ) : (
                      <TableCell>{this.state.email}</TableCell>
                    )}
                  </TableRow>
                  <TableRow>
                    <TableCell component={'th'}>
                      <b>
                        <span>*&nbsp;</span>
                        {lang === 'kor' ? '비밀번호' : 'Password'}
                      </b>
                    </TableCell>

                    <TableCell>
                      <OutlinedInput
                        className={classes.OutlinedInput}
                        style={{ width: '49%' }}
                        id={'password'}
                        type="password"
                        onChange={(e) => {
                          this.handleChange('password', e);
                        }}
                        disabled={this.state.ban}
                        //value={this.state.password}
                      />
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell component={'th'}>
                      <b>
                        <span>*&nbsp;</span>
                        {lang === 'kor' ? '비밀번호 확인' : 'Verify Password'}
                      </b>
                    </TableCell>

                    <TableCell>
                      <OutlinedInput
                        className={classes.OutlinedInput}
                        style={{ width: '49%' }}
                        id={'chkPw'}
                        type="password"
                        onChange={(e) => {
                          this.handleChange('chkPw', e);
                        }}
                        error={this.state.chkPw && this.state.chkPw !== this.state.password ? true : false}
                        disabled={this.state.ban}
                      />
                      {!this.state.chkPw ? (
                        <span style={{ color: 'black' }}>&nbsp;&nbsp;&nbsp; Re-enter your password.</span>
                      ) : this.state.chkPw && this.state.chkPw === this.state.password ? (
                        <span style={{ color: 'blue' }}>&nbsp;</span>
                      ) : (
                        <span style={{ color: 'red' }}>&nbsp;&nbsp;&nbsp; Passwords do not match.</span>
                      )}
                    </TableCell>
                  </TableRow>
                  {lang === 'kor' && (
                    <TableRow>
                      <TableCell component={'th'}>
                        <b>
                          <span>*&nbsp;</span>회원구분
                        </b>
                      </TableCell>
                      <TableCell>
                        <FormControl component="fieldset">
                          <RadioGroup
                            //row
                            aria-label="kind"
                            name="kind"
                            className={classes.radioGroup}
                            onChange={(e) => {
                              this.handleChange('kind', e);
                            }}
                            value={this.state.kind}
                          >
                            <FormControlLabel value="개원의" control={<Radio />} label="개원의" disabled={this.state.ban} />
                            <FormControlLabel
                              value="개인병원_봉직의"
                              control={<Radio />}
                              label="개인병원 봉직의"
                              disabled={this.state.ban}
                            />
                            <FormControlLabel
                              value="수련병원_봉직의"
                              control={<Radio />}
                              label="수련병원 봉직의"
                              disabled={this.state.ban}
                            />
                            <FormControlLabel
                              value="기타종합병원_봉직의"
                              control={<Radio />}
                              label="기타종합병원 봉직의"
                              disabled={this.state.ban}
                            />

                            <FormControlLabel value="군의관_공보의" control={<Radio />} label="군의관, 공보의" disabled={this.state.ban} />
                            <FormControlLabel value="전공의" control={<Radio />} label="전공의" disabled={this.state.ban} />
                            <FormControlLabel
                              value="국내연수 외국인의사"
                              control={<Radio />}
                              label="국내연수 외국인의사"
                              disabled={this.state.ban}
                            />
                            <FormControlLabel value="동반자" control={<Radio />} label={'동반자'} disabled={this.state.ban} />
                          </RadioGroup>
                        </FormControl>
                      </TableCell>
                    </TableRow>
                  )}
                  {(this.state.kind === '동반자' || this.state.kind === '국내연수 외국인의사') && (
                    <>
                      <TableRow>
                        <TableCell component={'th'} rowSpan={2}>
                          <b>
                            <span>*&nbsp;</span>추천인
                          </b>
                        </TableCell>
                        <TableCell>
                          <span>성명(국문)</span>
                          {this.props.type === 'JOIN' ? (
                            this.state.kind === '동반자' || this.state.kind === '국내연수 외국인의사' ? (
                              <OutlinedInput
                                className={classes.OutlinedInput}
                                style={{ width: '49%', marginLeft: 24 }}
                                id={'name_kor_r'}
                                onChange={(e) => {
                                  this.handleChange('name_kor_r', e);
                                }}
                                value={this.state.name_kor_r}
                                inputRef={this.refNameKrR}
                              />
                            ) : (
                              <OutlinedInput
                                className={classes.OutlinedInput}
                                style={{ width: '49%', marginLeft: 24 }}
                                id={'name_kor'}
                                onChange={(e) => {
                                  this.handleChange('name_kor', e);
                                }}
                                value={this.state.name_kor}
                                inputRef={this.refNameKr}
                              />
                            )
                          ) : (
                            this.state.name_kor_r
                          )}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <span>의사면허번호</span>
                          {this.props.type === 'JOIN' ? (
                            <>
                              <OutlinedInput
                                className={classes.OutlinedInput}
                                style={{ width: '49%', marginLeft: 10 }}
                                id={'license'}
                                onChange={(e) => {
                                  this.handleChange('license', e);
                                }}
                                value={this.state.license}
                                inputRef={this.refLicense}
                              />
                              <Button
                                variant="contained"
                                color="primary"
                                disableElevation
                                style={{ fontSize: '1em', marginLeft: '1em' }}
                                // todo: sgwoo 2022 행사 등록확인용 명단 적용
                                onClick={this.confirmMember}
                                // onClick={() => {
                                //   swal('', '등록확인용 명단 적용', 'info');
                                // }}
                                disabled={this.state.isConfirmed === true ? true : false}
                              >
                                {this.state.isConfirmed === true ? '인증완료' : '인증하기'}
                              </Button>
                            </>
                          ) : (
                            this.state.license
                          )}
                        </TableCell>
                      </TableRow>
                    </>
                  )}
                  {lang === 'kor' && this.state.kind !== '국내연수 외국인의사' && (
                    <TableRow>
                      <TableCell component={'th'}>
                        <b>
                          <span>*&nbsp;</span>성명(국문)
                        </b>
                      </TableCell>

                      <TableCell>
                        {this.props.type === 'JOIN' ? (
                          <OutlinedInput
                            className={classes.OutlinedInput}
                            style={{ width: '49%' }}
                            id={'name_kor'}
                            onChange={(e) => {
                              this.handleChange('name_kor', e);
                            }}
                            value={this.state.name_kor}
                            inputRef={this.refNameKr}
                            disabled={
                              (this.state.ban && this.state.kind === '국내연수 외국인의사') ||
                              (this.state.ban && this.state.kind === '동반자')
                                ? true
                                : false
                            }
                          />
                        ) : (
                          this.state.name_kor
                        )}
                      </TableCell>
                    </TableRow>
                  )}

                  <TableRow>
                    <TableCell component={'th'}>
                      <b>
                        <span>*&nbsp;</span>
                        {lang === 'kor' ? '성명(영문)' : 'Name'}
                      </b>
                    </TableCell>

                    <TableCell>
                      <Grid container justifyContent="space-between" direction={lang === 'kor' ? 'row' : 'row-reverse'}>
                        <OutlinedInput
                          className={classes.OutlinedInput}
                          style={{ width: '49%' }}
                          id={'lastName'}
                          placeholder={lang === 'kor' ? 'Last Name(성)' : 'Last Name'}
                          onChange={(e) => {
                            this.handleChange('lastName', e);
                          }}
                          value={this.state.lastName}
                          disabled={
                            (this.state.ban && this.state.kind === '국내연수 외국인의사') ||
                            (this.state.ban && this.state.kind === '동반자')
                              ? true
                              : false
                          }
                        />
                        <OutlinedInput
                          className={classes.OutlinedInput}
                          style={{ width: '49%' }}
                          id={'firstName'}
                          placeholder={lang === 'kor' ? 'First Name(이름)' : 'First Name'}
                          onChange={(e) => {
                            this.handleChange('firstName', e);
                          }}
                          value={this.state.firstName}
                          disabled={
                            (this.state.ban && this.state.kind === '국내연수 외국인의사') ||
                            (this.state.ban && this.state.kind === '동반자')
                              ? true
                              : false
                          }
                        />
                      </Grid>
                    </TableCell>
                  </TableRow>
                  {lang === 'kor' && this.state.kind !== '국내연수 외국인의사' && this.state.kind !== '동반자' && (
                    <TableRow>
                      <TableCell component={'th'}>
                        <b>
                          <span>*&nbsp;</span>의사면허번호
                        </b>
                      </TableCell>

                      <TableCell style={{ display: 'flex' }}>
                        {this.props.type === 'JOIN' ? (
                          <>
                            <OutlinedInput
                              className={classes.OutlinedInput}
                              style={{ width: '49%' }}
                              type="number"
                              id={'license'}
                              onChange={(e) => {
                                this.handleChange('license', e);
                              }}
                              value={this.state.license}
                              inputRef={this.refLicense}
                              // disabled={this.state.isConfirmed == true ? true : false}
                            />
                            <Button
                              variant="contained"
                              color="primary"
                              disableElevation
                              style={{ fontSize: '1em', marginLeft: '1em' }}
                              // todo: sgwoo 2022 행사 등록확인용 명단 적용
                              onClick={this.confirmMember}
                              disabled={this.state.isConfirmed === true ? true : false}
                            >
                              {this.state.isConfirmed === true ? '인증완료' : '인증하기'}
                            </Button>
                          </>
                        ) : (
                          this.state.license
                        )}
                      </TableCell>
                    </TableRow>
                  )}

                  <TableRow>
                    <TableCell component={'th'}>
                      <b>
                        <span>*&nbsp;</span>Title
                      </b>
                    </TableCell>

                    <TableCell>
                      <FormControl component="fieldset">
                        <RadioGroup
                          row
                          aria-label="type"
                          name="title"
                          className={classes.radioGroup}
                          onChange={(e) => {
                            this.handleChange('title', e);
                          }}
                          value={this.state.title}
                        >
                          <FormControlLabel value="Prof." control={<Radio />} label="Prof." disabled={this.state.ban} />
                          <FormControlLabel value="Dr." control={<Radio />} label="Dr." disabled={this.state.ban} />
                          <FormControlLabel value="Mr." control={<Radio />} label="Mr." disabled={this.state.ban} />
                          <FormControlLabel value="Ms." control={<Radio />} label="Ms." disabled={this.state.ban} />
                          <FormControlLabel value="Others" control={<Radio />} label="Others" disabled={this.state.ban} />
                        </RadioGroup>
                      </FormControl>
                      <OutlinedInput
                        className={classes.OutlinedInput}
                        style={{ width: '36%' }}
                        disabled={this.state.title !== 'Others'}
                        id={'titleOthers'}
                        value={this.state.title === 'Others' ? this.state.titleOthers : ''}
                        onChange={(e) => this.handleChange('titleOthers', e)}
                        // disabled={this.state.ban}
                      />
                    </TableCell>
                  </TableRow>
                  {lang !== 'kor' && (
                    <TableRow>
                      <TableCell component={'th'}>
                        <b>
                          <span>*&nbsp;</span>Department
                        </b>
                      </TableCell>

                      <TableCell>
                        <OutlinedInput
                          className={classes.OutlinedInput}
                          id={'department'}
                          value={this.state.department}
                          onChange={(e) => this.handleChange('department', e)}
                          disabled={this.state.ban}
                        />
                      </TableCell>
                    </TableRow>
                  )}

                  <TableRow>
                    <TableCell component={'th'}>
                      <b>
                        <span>*&nbsp;</span> {lang === 'kor' ? '소속(근무처)' : 'Affiliation'}
                      </b>
                    </TableCell>

                    <TableCell>
                      {lang === 'kor' ? (
                        <>
                          <FormControl variant="outlined" size={'small'} style={{ width: '49%', marginBottom: '10px' }}>
                            <Select
                              required
                              displayEmpty
                              value={
                                this.props.isMypage
                                  ? this.state.positionShort
                                    ? this.state.positionShort
                                    : '기타'
                                  : this.state.positionShort
                              }
                              onChange={(e) => {
                                this.selectPositionKr(e.target.value);
                              }}
                              disabled={this.state.ban}
                            >
                              <MenuItem value={''}>SELECT</MenuItem>
                              <MenuItem value={'기타'}>기타</MenuItem>
                              {this.state.hospitalList &&
                                this.state.hospitalList.map((hospital, idx) => {
                                  return (
                                    <MenuItem value={hospital.office_k} key={idx}>
                                      {hospital.office_k}
                                    </MenuItem>
                                  );
                                })}
                            </Select>
                          </FormControl>
                          <Grid container justifyContent="space-between" alignItems="center" style={{ marginBottom: '10px' }}>
                            <span>국문</span>{' '}
                            <OutlinedInput
                              className={classes.OutlinedInput}
                              style={{ width: '95%' }}
                              id={'position'}
                              onChange={(e) => {
                                this.handleChange('position', e);
                              }}
                              value={this.state.position}
                              disabled={this.state.ban}
                            />
                          </Grid>
                        </>
                      ) : (
                        ''
                      )}

                      <Grid container justifyContent="space-between" alignItems="center">
                        {lang === 'kor' ? <span>영문</span> : ''}
                        <OutlinedInput
                          className={classes.OutlinedInput}
                          style={{ width: '95%' }}
                          id={'positionEn'}
                          onChange={(e) => {
                            this.handleChange('positionEn', e);
                          }}
                          value={this.state.positionEn}
                          disabled={this.state.ban}
                        />
                      </Grid>
                      <Grid container>
                        <span style={{ fontWeight: 'bold', paddingTop: 8 }}>
                          * 소속(근무처) 자동입력 항목 중, "강원대학교병원" 은 리스트의 가장 아래 부분에 있습니다.
                        </span>
                      </Grid>
                    </TableCell>
                  </TableRow>
                  {/* <TableRow>
                    <TableCell component={'th'}>
                      <b>
                        <span>*&nbsp;</span> {lang === 'kor' ? '주소' : 'Address'}
                      </b>
                    </TableCell>
                    <TableCell>
                      <Grid container>
                        {
                          lang === 'kor' && (
                            <OutlinedInput
                              id="postalCode"
                              className={classes.OutlinedInput}
                              style={{ width: '40%', marginRight: '10px', marginBottom: '10px' }}
                              value={this.state.postalCode || ''}
                              onChange={(e) => {
                                this.handleChange('postalCode', e);
                              }}
                            />
                          )
                          // ) : (
                          // <OutlinedInput
                          //   className={classes.OutlinedInput}
                          //   style={{ width: '40%', marginRight: '10px' }}
                          //   id={'postalCode'}
                          //   value={this.state.postalCode || ''}
                          //   placeholder={'Postal Code'}
                          //   onChange={(e) => {
                          //     this.handleChange('postalCode', e);
                          //   }}
                          // />
                          // ''
                          //)
                        }
                        {lang === 'kor' ? (
                          <Button
                            variant="contained"
                            color="primary"
                            disableElevation
                            className={classes.btn}
                            onClick={() => this.setPopupOpen()}
                            style={{ marginBottom: '10px' }}
                          >
                            우편번호찾기
                          </Button>
                        ) : (
                          ''
                        )}
                      </Grid>
                      <Grid container justifyContent="space-between" alignItems="center">
                        {lang === 'kor' ? (
                          <>
                            <span>국문</span>
                            <OutlinedInput
                              className={classes.OutlinedInput}
                              style={{ width: '95%', marginBottom: '10px' }}
                              id={'address'}
                              value={this.state.address}
                              onChange={(e) => this.handleChange('address', e)}
                            />
                          </>
                        ) : (
                          ''
                        )}
                      </Grid>
                      <Grid container justifyContent="space-between" alignItems="center">
                        {lang === 'kor' ? <span>영문</span> : ''}
                        <OutlinedInput
                          className={classes.OutlinedInput}
                          style={{ width: '95%' }}
                          id={'addressEn'}
                          value={this.state.addressEn}
                          onChange={(e) => this.handleChange('addressEn', e)}
                        />
                      </Grid>
                    </TableCell>
                  </TableRow>
                  {lang === 'eng' && (
                    <TableRow>
                      <TableCell component={'th'}>
                        <b>
                          <span>*&nbsp;</span>City
                        </b>
                      </TableCell>

                      <TableCell>
                        <OutlinedInput
                          className={classes.OutlinedInput}
                          id={'city'}
                          value={this.state.city}
                          onChange={(e) => this.handleChange('city', e)}
                        />
                      </TableCell>
                    </TableRow>
                  )} */}
                  <TableRow>
                    <TableCell component={'th'}>
                      <b>
                        <span>*&nbsp;</span>
                        {lang === 'kor' ? '핸드폰 번호' : 'Mobile'}
                      </b>
                    </TableCell>

                    <TableCell>
                      <div style={{ width: '100%' }}>
                        <Grid container alignItems="center" style={{ width: '100%', marginBottom: '10px' }}>
                          {lang === 'kor' ? (
                            <>
                              <p>+</p>&nbsp;
                              <p style={{ width: '15%', textAlign: 'center' }}>국가번호</p>&nbsp;<p>-</p>&nbsp;
                              <p style={{ width: '54%', textAlign: 'center' }}>핸드폰번호</p>
                            </>
                          ) : (
                            <>
                              <p>+</p>&nbsp;
                              <p style={{ width: '15%', textAlign: 'center' }}>Country Code</p>&nbsp;<p>-</p>&nbsp;
                              <p style={{ width: '50%', textAlign: 'center' }}>Phone Number</p>
                            </>
                          )}
                        </Grid>
                        <Grid container alignItems="center" style={{ width: '100%' }}>
                          <p>+</p>&nbsp;
                          <OutlinedInput
                            className={classes.OutlinedInput}
                            style={{ width: lang === 'kor' ? '15%' : '15%' }}
                            type="number"
                            value={this.state.hp1}
                            onChange={(e) => {
                              this.handleChange('hp1', e);
                            }}
                            disabled={this.state.ban}
                          />
                          &nbsp;
                          <p className={classes.icon}>-</p>&nbsp;
                          <OutlinedInput
                            className={classes.OutlinedInput}
                            style={{ width: lang === 'kor' ? '17%' : '50%' }}
                            type="number"
                            value={this.state.hp2}
                            onChange={(e) => {
                              this.handleChange('hp2', e);
                            }}
                            disabled={this.state.ban}
                          />
                          &nbsp;
                          {lang === 'kor' && (
                            <>
                              <p className={classes.icon}>-</p>&nbsp;
                              <OutlinedInput
                                className={classes.OutlinedInput}
                                style={{ width: lang === 'kor' ? '17%' : '17%' }}
                                type="number"
                                value={this.state.hp3}
                                onChange={(e) => {
                                  this.handleChange('hp3', e);
                                }}
                                disabled={this.state.ban}
                              />
                              &nbsp;
                              <p className={classes.icon}>-</p>&nbsp;
                              <OutlinedInput
                                className={classes.OutlinedInput}
                                style={{ width: lang === 'kor' ? '17%' : '17%' }}
                                type="number"
                                value={this.state.hp4}
                                onChange={(e) => {
                                  this.handleChange('hp4', e);
                                }}
                                disabled={this.state.ban}
                              />
                            </>
                          )}
                        </Grid>
                      </div>
                      {/* <p>* 핸드폰번호 입력 시 “-” 넣어 입력 부탁 드립니다. Ex) +82-10-1234-1234</p> */}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell component={'th'}>
                      <b>{lang === 'kor' ? '전화번호' : 'Telephone'}</b>
                    </TableCell>

                    <TableCell>
                      <div style={{ width: '100%' }}>
                        <Grid container alignItems="center" style={{ width: '100%', marginBottom: '10px' }}>
                          {lang === 'kor' ? (
                            <>
                              <p>+</p>&nbsp;
                              <p style={{ width: '15%', textAlign: 'center' }}>국가번호</p>&nbsp;<p>-</p>&nbsp;
                              <p style={{ width: '17%', textAlign: 'center' }}>지역번호</p>&nbsp;
                              <p>-</p>&nbsp;
                              <p style={{ width: '35%', textAlign: 'center' }}>전화번호</p>
                            </>
                          ) : (
                            <>
                              <p>+</p>&nbsp;
                              <p style={{ width: '15%', textAlign: 'center' }}>Country code</p>&nbsp;<p>-</p>&nbsp;
                              {lang === 'kor' && (
                                <>
                                  <p style={{ width: '17%', textAlign: 'center' }}>Area code</p>&nbsp;
                                  <p>-</p>&nbsp;
                                </>
                              )}
                              <p style={{ width: '50%', textAlign: 'center' }}>Telephone Number</p>
                            </>
                          )}
                        </Grid>
                        <Grid container alignItems="center" style={{ width: '100%' }}>
                          <p>+</p>&nbsp;
                          <OutlinedInput
                            className={classes.OutlinedInput}
                            style={{ width: '15%' }}
                            type="number"
                            value={this.state.tel1}
                            onChange={(e) => {
                              this.handleChange('tel1', e);
                            }}
                            disabled={this.state.ban}
                          />
                          &nbsp;
                          <p className={classes.icon}>-</p>&nbsp;
                          <OutlinedInput
                            className={classes.OutlinedInput}
                            style={{ width: lang === 'kor' ? '17%' : '50%' }}
                            type="number"
                            value={this.state.tel2}
                            onChange={(e) => {
                              this.handleChange('tel2', e);
                            }}
                            disabled={this.state.ban}
                          />
                          &nbsp;
                          {lang === 'kor' && (
                            <>
                              <p className={classes.icon}>-</p>&nbsp;
                              <OutlinedInput
                                className={classes.OutlinedInput}
                                style={{ width: '17%' }}
                                type="number"
                                value={this.state.tel3}
                                onChange={(e) => {
                                  this.handleChange('tel3', e);
                                }}
                                disabled={this.state.ban}
                              />
                              &nbsp;
                              <p className={classes.icon}>-</p>&nbsp;
                              <OutlinedInput
                                className={classes.OutlinedInput}
                                style={{ width: '17%' }}
                                type="number"
                                value={this.state.tel4}
                                onChange={(e) => {
                                  this.handleChange('tel4', e);
                                }}
                                disabled={this.state.ban}
                              />
                            </>
                          )}
                        </Grid>
                      </div>
                      {/* <p>* 전화번호 입력 시 “-” 넣어 입력 부탁 드립니다. Ex) +82-2-123-1234</p> */}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell component={'th'}>
                      <b>{lang === 'kor' ? '기타사항' : 'Remark'} </b>
                    </TableCell>
                    <TableCell>
                      <OutlinedInput
                        className={classes.OutlinedInput}
                        onChange={(e) => this.handleChange('etc', e)}
                        value={this.state.etc}
                        disabled={this.state.ban}
                      />
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Grid>
            <Grid item xs={8}>
              <Grid container justifyContent="center" alignitems="center" style={{ margin: this.props.theme.spacing(5, 0) }}>
                {this.props.type === 'JOIN' ? (
                  <ConfirmButton
                    onClick={this.handleSignUp}
                    color="primary"
                    // disabled={
                    //   lang === 'kor'
                    //     ? this.state.agree === 'N' ||
                    //       this.state.email === '' ||
                    //       this.state.password === '' ||
                    //       this.state.license === '' ||
                    //       this.state.title === '' ||
                    //       this.state.address === '' ||
                    //       this.state.addressEn === '' ||
                    //       this.state.mobile === ''
                    //     : this.state.agree === 'N' ||
                    //       this.state.email === '' ||
                    //       this.state.password === '' ||
                    //       this.state.title === '' ||
                    //       this.state.department === '' ||
                    //       this.state.addressEn === '' ||
                    //       this.state.city === '' ||
                    //       this.state.mobile === ''
                    // }
                  >
                    Confirm
                  </ConfirmButton>
                ) : (
                  <ConfirmButton onClick={this.handleUpdate} color="primary">
                    Modify
                  </ConfirmButton>
                )}
                <div style={{ width: '1em' }} />
                <ConfirmButton color="secondary" onClick={this.handleCancel}>
                  Cancel
                </ConfirmButton>
              </Grid>
            </Grid>
          </Grid>
          {this.state.popUpOpen && (
            <div id="popupDom" className={classes.popupDiv}>
              <Paper elevation={3} className={classes.popupPaper}>
                <Grid container justifyContent="flex-end">
                  <IconButton aria-label="close" onClick={() => this.setPopupClose()}>
                    <CloseIcon />
                  </IconButton>
                </Grid>
                <DaumPostcode onComplete={handleComplete} style={{ height: '450px' }} />
              </Paper>
            </div>
          )}
        </Container>
        {this.state.isSubmitting && (
          <div style={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)' }}>
            <CircularProgress size={100} thickness={5} style={{ color: this.props.theme.palette.secondary.point }} />
          </div>
        )}
      </>
    );
  }
}

export default withRouter(withStyles(styles, { withTheme: true })(JoinForm));
